export const CLASSIC_SCROLLBARS_CLASS = 'classic-scrollbars';

// Overlay scrollbars (phones, macOS by default) take no room; classic ones (Windows, a Mac set to
// "always show") do. Only the classic kind gets restyled: styling ::-webkit-scrollbar on a Mac would
// swap its fading overlay bars for permanent ones.
export const measureScrollbarWidth = () => {
  const probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll;';
  document.body.appendChild(probe);
  const width = probe.offsetWidth - probe.clientWidth;
  probe.remove();

  return width;
};

export const applyScrollbarStyle = (width = measureScrollbarWidth()) => {
  document.documentElement.classList.toggle(CLASSIC_SCROLLBARS_CLASS, width > 0);
};
